import * as actions from './tutorial.actions'

import * as tutorialConstants from './tutorial.constants'
import * as questionsConstants from './questions.constants'

const initialFeedBack = {
  answerId: undefined,
  coins: undefined,
  correct: undefined,
}

const initialState = {
  tutorialMode: false,
  urlMode: false,
  academySwitch: false,
  attackSuccess: false,
  userInfo: {},
  ownPlayerID: '5c934d95fdc4bc00134da4e5',
  miningScreen: 'tutorial_mining_select_screen',
  turn: 1,
  phase: 2,
  confidentialNumber: 0,
  miningFeedBack: initialFeedBack,
  prizeCoins: 8,
  debatesInfo: [],
  totalDisputes: 1,
  playerList: tutorialConstants.playerList,
  ui: tutorialConstants.initialUI,
  userMap: tutorialConstants.initialMap,
  indicators: tutorialConstants.indicators,
  groupData: tutorialConstants.initialGroupData,
  userData: tutorialConstants.initialUserData,
  currentUser: tutorialConstants.initialCurrentUser,
  voteQuestion: {},
  currentQuestion: questionsConstants.tutorialQuestions.turn1[0],
  buildingScreen: {
    displayingBuildingCard: 'home',
  },
  currentStore: 'userMap',
  oldMessageId: '',
  tutorialMessage: {
    show: false,
    message: '',
  },
  currentBattle: tutorialConstants.battleOne,
  individualBattle: null,
  profileBattles: [],
  rivalInfo: tutorialConstants.playerList[tutorialConstants.initialProfileBattles[0].createdBy],
  battleQuestions: questionsConstants.questions,
  visitorMap: {
    mapId: null,
    buildings: {},
    removedRocks: {},
    visitorId: null,
  },
  allVisitors: tutorialConstants.visitorMaps,
  activity: [],
}

const actionsMap = {
  [actions.INIT_TUTORIAL_URL]: (state) => {
    return {
      ...state,
      ui: tutorialConstants.initialUrlUI,
    }
  },
  [actions.INIT_TUTORIAL]: (state) => {
    return {
      ...state,
      tutorialMode: true,
    }
  },
  [actions.END_TUTORIAL]: () => {
    return initialState
  },
  [actions.SET_USER_MAP]: (state, action) => {
    const data = action.data
    return {
      ...state,
      userMap: data,
    }
  },
  [actions.SET_CURRENT_STORE]: (state, action) => {
    let store = action.data
    return {
      ...state,
      currentStore: store,
    }
  },

  [actions.SET_VISITOR_MAP]: (state, action) => {
    return {
      ...state,
      visitorMap: {
        ...state.visitorMap,
        ...action.data,
      },
      currentStore: action.data.mapId != null ? 'visitorMap' : 'userMap',
    }
  },
  [actions.SAVE_VISITOR_MAP]: (state) => {
    const visitorMap = state.visitorMap
    const uid = visitorMap.visitorId
    let payload = { ...visitorMap }
    delete payload.visitorId
    return {
      ...state,
      allVisitors: {
        ...state.allVisitors,
        [uid]: {
          ...state.allVisitors[uid],
          ...payload,
        },
      },
    }
  },

  [actions.MODIFY_VISITOR_BUILDING]: (state, action) => {
    const { building, uid } = action.data
    const visitorMap = state.visitorMap
    let modifiedMap = {}

    if (visitorMap.visitorId == uid) {
      modifiedMap = {
        ...visitorMap,
        buildings: {
          ...visitorMap.buildings,
          [`${building.q}_${building.r}`]: {
            ...visitorMap.buildings[`${building.q}_${building.r}`],
            blocked: building.blocked,
          },
        },
      }
    } else {
      modifiedMap = visitorMap
    }

    return {
      ...state,
      visitorMap: modifiedMap,
    }
  },

  [actions.SET_CONFIDENTIAL_NUMBER]: (state) => {
    const confidentialNumber = Math.floor(Math.random() * 9000) + 1000
    return {
      ...state,
      confidentialNumber,
      currentUser: {
        ...state.currentUser,
        name: '#' + confidentialNumber,
        colonyName: 'Colony_' + confidentialNumber,
      },
    }
  },

  [actions.SET_CURRENT_USER]: (state, action) => {
    return {
      ...state,
      currentUser: {
        ...state.currentUser,
        ...action.data,
      },
    }
  },

  [actions.MODIFY_BUILDINGS]: (state, action) => {
    const buildings = action.data
    return {
      ...state,
      userMap: {
        ...state.userMap,
        buildings: {
          ...state.userMap.buildings,
          ...buildings,
        },
      },
    }
  },
  [actions.GO_TO]: (state, action) => {
    let { phase, turn } = action.data

    if (!turn) {
      turn = state.turn
    }
    return {
      ...state,
      userData: {
        ...state.userData,
        phase,
        turn,
      },
      phase,
      turn,
      groupData: {
        ...state.groupData,
        session: Math.ceil(turn / 2),
      },
    }
  },
  [actions.SHOW_MESSAGE]: (state, action) => {
    const { show, message } = action.data
    return {
      ...state,
      oldMessageId: message,
      ui: {
        ...state.ui,
        tutorialMessage: {
          show,
          message,
        },
      },
    }
  },
  [actions.HIDE_MESSAGE]: (state) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        tutorialMessage: {
          show: false,
          message: '',
        },
      },
    }
  },
  [actions.MODIFY_PRIZE]: (state, action) => {
    return {
      ...state,
      prizeCoins: action.data,
    }
  },
  [actions.CHANGE_MINING_SCREEN_SUCCESS]: (state, action) => {
    const screenId = action.data

    return {
      ...state,
      miningScreen: screenId,
    }
  },
  [actions.SET_FEED_BACK]: (state, action) => {
    const miningFeedBack = action.data

    return {
      ...state,
      miningFeedBack,
    }
  },
  [actions.ADD_COINS]: (state, action) => {
    const coins = action.data

    const coinsIndicatorIndex = state.indicators.findIndex((i) => i.id === 'coins')

    let indicators = [...state.indicators]
    indicators[coinsIndicatorIndex].value += coins
    return {
      ...state,
      indicators,
      userData: {
        ...state.userData,
        coins: state.userData.coins + coins,
      },
    }
  },
  [actions.MODIFY_INDICATORS]: (state, action) => {
    const indicators = action.data

    let storeIndicators = [...state.indicators]
    Object.keys(indicators).map((key) => {
      let index = storeIndicators.findIndex((i) => i.id === key)
      if (index >= 0) {
        storeIndicators[index].value = indicators[key]
      }
    })
    return {
      ...state,
      storeIndicators,
    }
  },
  [actions.CLEAR_FEED_BACK]: (state) => {
    return {
      ...state,
      miningFeedBack: initialFeedBack,
    }
  },
  [actions.MODIFY_DISPUTES_AMOUNT]: (state, action) => {
    return {
      ...state,
      totalDisputes: action.data,
    }
  },
  [actions.SET_COUNTERS_DATA]: (state, action) => {
    const counters = action.data

    return {
      ...state,
      userData: {
        ...state.userData,
        counters: {
          ...state.userData.counters,
          ...counters,
        },
      },
    }
  },
  [actions.SET_USER_DATA]: (state, action) => {
    const values = action.data

    return {
      ...state,
      userData: {
        ...state.userData,
        ...values,
      },
    }
  },
  [actions.SET_CURRENT_QUESTION]: (state, action) => {
    const questionIndex = action.data
    return {
      ...state,
      currentQuestion: questionsConstants.tutorialQuestions[`turn${state.turn}`][questionIndex],
    }
  },
  [actions.SET_VOTE_QUESTION]: (state, action) => {
    return {
      ...state,
      voteQuestion: action.data,
    }
  },
  [actions.CLICK_ACADEMY_SWITCH]: (state) => {
    return {
      ...state,
      academySwitch: !state.academySwitch,
    }
  },
  [actions.CREATE_BUILDING_SUCCESS]: (state, action) => {
    const building = action.data
    return {
      ...state,
      buildingScreen: {
        displayingBuildingCard: building.name,
      },
      userMap: {
        ...state.userMap,
        buildings: {
          ...state.userMap.buildings,
          [`${building.q}_${building.r}`]: building,
        },
      },
    }
  },
  [actions.UPGRADE_BUILDING_SUCCESS]: (state, action) => {
    const payload = action.data
    return {
      ...state,
      userMap: {
        ...state.userMap,
        buildings: {
          ...state.userMap.buildings,
          [payload.id]: {
            ...state.userMap.buildings[payload.id],
            evolving: payload.evolving,
          },
        },
      },
    }
  },
  [actions.REMOVE_QUESTION]: (state) => {
    return {
      ...state,
      currentQuestion: null,
    }
  },
  [actions.SET_MINING_UI]: (state, action) => {
    const miningUI = action.data
    return {
      ...state,
      ui: {
        ...state.ui,
        mining: {
          ...state.ui.mining,
          ...miningUI.mining,
        },
      },
    }
  },
  [actions.SET_MAP_UI]: (state, action) => {
    const map = action.data
    return {
      ...state,
      ui: {
        ...state.ui,
        map: {
          ...state.ui.map,
          ...map,
        },
      },
    }
  },
  [actions.SHOW_INDICATORS]: (state) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        map: {
          ...state.ui.map,
          indicators: true,
        },
      },
    }
  },
  [actions.SET_DEBATES_INFO]: (state, action) => {
    const debates = action.data
    return {
      ...state,
      debatesInfo: debates,
    }
  },
  [actions.SET_PHASE1_HIDE_UI]: (state, action) => {
    const phase1 = action.data
    return {
      ...state,
      ui: {
        ...state.ui,
        phase1Hide: {
          ...state.ui.phase1Hide,
          ...phase1,
        },
      },
    }
  },

  [actions.SET_AVAILABLE_BUILDINGS]: (state) => {
    // const data = action.data
    // return {
    //   ...state,
    //   ui: {
    //     ...state.ui,
    //     building: {
    //       ...state.ui.building,
    //       buildingsAvailable: data,
    //     },
    //   },
    // }

    return state
  },

  [actions.SET_BATTLE]: (state, action) => {
    const battle = action.data
    return {
      ...state,
      currentBattle: battle,
      rivalInfo: tutorialConstants.playerList[battle.rivalId],
      attackSuccess: true,
    }
  },
  [actions.SET_INDIVIDUAL_BATTLE]: (state, action) => {
    const battle = action.data
    return {
      ...state,
      individualBattle: battle,
    }
  },
  [actions.START_CURRENT_BATTLE]: (state) => {
    let results = { ...state.currentBattle.results }
    results[state.ownPlayerID] = { startTime: new Date().valueOf() }
    return {
      ...state,
      currentBattle: {
        ...state.currentBattle,
        results: results,
      },
    }
  },
  [actions.END_CURRENT_BATTLE]: (state) => {
    let results = { ...state.currentBattle.results }
    const { phase, turn } = state
    let won = turn == 4 && phase == 1
    results[state.ownPlayerID] = {
      ...state.currentBattle.results[state.ownPlayerID],
      endTime: new Date().valueOf(),
      finished: true,
    }
    const totalDuration = results[state.ownPlayerID].endTime - results[state.ownPlayerID].startTime
    const currentBattle = {
      ...state.currentBattle,
      results: results,
      resolvedForDefender: won, //TODO check if other use cases
      winnerId: won ? state.ownPlayerID : '',
      wrongAnswers: state.currentBattle.info.fails,
      correctAnswers: state.currentBattle.info.hits,
      totalDuration: totalDuration,
    }
    let rivalId = currentBattle.rivalId
    let profileBattles = state.profileBattles
    profileBattles.push({ ...currentBattle })
    return {
      ...state,
      currentBattle: currentBattle,
      rivalInfo: null,
      profileBattles: profileBattles,
      currentUser: {
        ...state.currentUser,
        batd: state.currentUser.batd + 1,
      },
      playerList: {
        ...state.playerList,
        [rivalId]: {
          ...state.playerList[rivalId],
          batp: state.playerList[rivalId].batp + 1,
        },
      },
    }
  },
  [actions.GIVE_UP_BATTLE]: (state) => {
    let results = { ...state.currentBattle.results }
    const { phase, turn } = state
    let canContinue = turn == 4 && phase == 1
    const totalDuration = results[state.ownPlayerID].endTime - results[state.ownPlayerID].startTime
    const actualBattle = state.currentBattle
    const actualProfileBattles = state.profileBattles
    const currentBattle = {
      ...state.currentBattle,
      results: results,
      resolvedForDefender: false,
      wrongAnswers: state.currentBattle.info.fails,
      correctAnswers: state.currentBattle.info.hits,
      totalDuration: totalDuration,
    }
    let rivalId = currentBattle.rivalId
    let profileBattles = [...state.profileBattles]
    profileBattles.push({ ...currentBattle })
    return {
      ...state,
      currentBattle: canContinue ? actualBattle : currentBattle,
      profileBattles: canContinue ? actualProfileBattles : profileBattles,
      currentUser: {
        ...state.currentUser,
        batd: state.currentUser.batd + 1,
      },
      playerList: {
        ...state.playerList,
        [rivalId]: {
          ...state.playerList[rivalId],
          batp: state.playerList[rivalId].batp + 1,
        },
      },
    }
  },

  [actions.ANSWER_BATTLE_QUESTION]: (state, action) => {
    const question = action.data
    const correctChoice = question.choices.find((e) => e.isCorrect == true).key
    const right = correctChoice == question.selectedKey
    let results = {
      ...state.currentBattle.results,
    }
    results[state.ownPlayerID] = { ...state.currentBattle.results[state.ownPlayerID] } || {}
    results[state.ownPlayerID][question._id] = {
      selectedKey: question.selectedKey,
      right: right,
      correctChoice: correctChoice,
    }
    return {
      ...state,
      currentBattle: {
        ...state.currentBattle,
        info: {
          hits: state.currentBattle.info.hits + (right ? 1 : 0),
          fails: state.currentBattle.info.fails + (right ? 0 : 1),
          question: state.currentBattle.info.question + 1,
        },
        results: results,
      },
    }
  },

  [actions.BACK_TO_RANKING]: (state, action) => {
    let backToRanking = action.data
    return {
      ...state,
      backToRanking: backToRanking,
    }
  },
  [actions.SET_USER_INFO_FAKE]: (state, action) => {
    const userInfo = action.data
    return {
      ...state,
      userInfo,
    }
  },

  [actions.SET_ACTIVITY]: (state, action) => {
    const activity = action.data
    return {
      ...state,
      activity,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
